module.exports = __webpack_public_path__ + "img/stack06.223474e0.svg";